export const activitiesTrueFalseMapping = {
  "": "-----",
  true: "Yes",
  false: "No",
};
